// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__y6ACV","fileBtn":"File_fileBtn__1gBds","closeBtn":"File_closeBtn__2oPgB","fileSelected":"File_fileSelected__1P-if","disabled":"File_disabled__3f_O5"};